import { render, staticRenderFns } from "./AssistantStepNavigation.vue?vue&type=template&id=27a06639"
import script from "./AssistantStepNavigation.vue?vue&type=script&lang=ts"
export * from "./AssistantStepNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports